import { SCORE_CARDS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/score_cards_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['associatedScoreCardsForSourcingEvent']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
